import React from 'react';
import clsx from 'clsx';
import { useRecoilState } from 'recoil';
import { createStyles, makeStyles } from '@material-ui/core';
import ViewListIcon from '@material-ui/icons/ViewListTwoTone';
import ViewModuleIcon from '@material-ui/icons/ViewModuleTwoTone';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { StandardDivProps } from '@sprinx/react-mui-components';
import { CatalogueView, catalogueViewModeState } from '../../../api/products/catalogue';

type CataloguePageListToolbarViewSwitcherProps = StandardDivProps<CataloguePageListToolbarViewSwitcherClassKey>;

type CataloguePageListToolbarViewSwitcherClassKey = 'root';

const useStyles = makeStyles(
  (/* theme: Theme */) =>
    createStyles<CataloguePageListToolbarViewSwitcherClassKey, {}>({
      root: {},
    }),
  { name: 'CataloguePageListToolbar' },
);

const CataloguePageListToolbarViewSwitcher = React.forwardRef<
  HTMLDivElement,
  CataloguePageListToolbarViewSwitcherProps
>(({ className, classes: pClasses }, ref) => {
  const classes = useStyles({ classes: pClasses });

  const [catalogueView, setCatalogueView] = useRecoilState(catalogueViewModeState);

  const handleCatalogueViewChange = (v: CatalogueView) => {
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.setItem('catalogueView', v);
    }
    setCatalogueView(v);
  };

  return (
    <div className={clsx(classes.root, className)} ref={ref}>
      <ToggleButtonGroup
        value={catalogueView}
        onChange={(evnt: any, v: CatalogueView) => handleCatalogueViewChange(v)}
        exclusive
        size='small'
      >
        <ToggleButton value='card' aria-label='card' disabled={catalogueView === 'card'}>
          <ViewModuleIcon />
        </ToggleButton>
        <ToggleButton value='row' aria-label='row' disabled={catalogueView === 'row'}>
          <ViewListIcon />
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
});

CataloguePageListToolbarViewSwitcher.displayName = 'CataloguePageListToolbarViewSwitcher';

export default CataloguePageListToolbarViewSwitcher;
